import * as yup from 'yup';
import { recipeIngredient } from '@/features/recipes/schema';

export const mealLogEntrySchema = yup.object({
  date: yup.string().required('Date is required'),
  meal_type: yup.string().oneOf(['breakfast', 'lunch', 'dinner']).required('Meal type is required'),
  portion_size: yup.number().min(0.1, 'Portion size must be at least 0.1').max(10, 'Portion size must be at most 10').required('Portion size is required'),
  ingredients: yup.array().of(recipeIngredient).required('Ingredients are required'),  
});

export function newMealLogEntry() {
  return {
    date: new Date().toISOString().split('T')[0],
    meal_type: 'breakfast',
    portion_size: 1.0,
    ingredients: [],
  };
}
